// extracted by mini-css-extract-plugin
module.exports = {"stepperCompleted":"#6ace09","stepperActive":"#151c3f","stepperTextColor":"#fff"};